import axios from "axios";
import {projectId} from "../config/firebase-config";

/**
 * Meldet dem Mailserver einen gerade angelegten Mangel. Empfänger, CC und
 * Inhalt baut der Server selbst aus Firestore; hier geht nur der Verweis raus —
 * keine Adressen, keine Inhalte, kein API-Key.
 *
 * Kein `.catch()`: wer meldet, behandelt den Fehlschlag auch.
 */
export const benachrichtigeMailserver = ({fahrzeugId, mangelId}) =>
  axios.post(process.env.REACT_APP_EMAIL_ENDPOINT_MANGELGEMELDET, {
    projectId,
    fahrzeugId,
    mangelId,
  });
